export const photos = {
    state: {
        status: 'idle',
        photos: [],
        routerBack: {}
    },
    mutations: {
        SET_PHOTOS_STATUS(state, status) {
            state.status = status
        },
        SET_PHOTOS_ROUTER_BACK(state, status) {
            state.routerBack = status
        },
        ADD_PHOTO(state, photo) {
            state.photos.push(photo)
        },
        REMOVE_PHOTOS(state, photosToRemove) {
            for(const photoToRemove of photosToRemove) {
                const idx = state.photos.findIndex(photo => photo.id === photoToRemove)
                if(idx > -1) {
                    state.photos.splice(idx, 1)
                }
            }
        },
        REMOVE_ALL_PHOTOS(state) {
            this.$vue.set(state, 'photos', [])
        }
    },
    actions: {
        addPhoto({ commit }, payload) {
            commit('ADD_PHOTO', {
                id: Date.now(),
                image: payload.image,
                url: payload.url ? payload.url : ''
            })
        },
        removePhotos({ commit }, photosToRemove) {
            commit('REMOVE_PHOTOS', photosToRemove)
        },
        removeAllPhotos({ commit }) {
            commit('REMOVE_ALL_PHOTOS')
        },
        fetchPhotos({ commit, dispatch, getters }, photoUrls) {
            const fetchPhoto = (photoUrl, photoUrls) => {
                if(!getters.photos.some(item => item.url === photoUrl)) {
                    if(photoUrl === undefined) {
                        return
                    }
                    commit('SET_PHOTOS_STATUS', 'loading')
                    let extension = photoUrl.split('.').pop()
                    if(extension === 'jpg') {
                        extension = 'jpeg'
                    }
                    if(extension === 'jpeg' || extension === 'png') {
                        return this.$api.get(photoUrl, { responseType: 'arraybuffer' }).then(response => {
                            dispatch('addPhoto', {
                                image: `data:image/${extension};base64,${Buffer.from(response.data, 'binary').toString('base64')}`,
                                url: photoUrl
                            })
                            if(photoUrls.length === getters.photos.length) {
                                commit('SET_PHOTOS_STATUS', 'idle')
                            }
                            if(getters.photos.length <= photoUrls.length) {
                                fetchPhoto(photoUrls[getters.photos.length])
                            }
                        }).catch(() => {
                            commit('SET_PHOTOS_STATUS', 'idle')
                        })
                    }
                }
            }
            fetchPhoto(photoUrls[0], photoUrls)
        },
        setPhotosRouterBack({ commit }, payload) {
            commit('SET_PHOTOS_ROUTER_BACK', payload)
        }
    },
    getters: {
        photosStatus: (state) => {
            return state.status
        },
        photos: (state) => {
            return state.photos
        },
        photosInBase64: (state) => {
            return state.photos.map(photo => photo.image)
        },
        photosRouterBack: (state) => {
            return state.routerBack
        }
    }
}
